// Copyright (C) 2017-2022 Smart code 203358507

const ColorPicker = require('./ColorPicker');

module.exports = ColorPicker;
